import { render, staticRenderFns } from "./block-educator.vue?vue&type=template&id=33394c83&scoped=true&"
import script from "./block-educator.vue?vue&type=script&lang=js&"
export * from "./block-educator.vue?vue&type=script&lang=js&"
import style0 from "./block-educator.vue?vue&type=style&index=0&id=33394c83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33394c83",
  null
  
)

export default component.exports